export interface PaginationResult<T> {
  paginatedData: T[]
  totalItems: number
  totalPages: number
  startIndex: number
  endIndex: number
}

export const paginate = <T>(
  data: T[],
  currentPage: number,
  itemsPerPage: number
): PaginationResult<T> => {
  const totalItems = data.length
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const paginatedData = data.slice(startIndex, endIndex)

  return {
    paginatedData,
    totalItems,
    totalPages,
    startIndex,
    endIndex
  }
}

